/* sb-dc-findropdown.js - one finishing control, in the right-hand panel.
   2026-09-12 (v3), 2026-09-15 (v4, collapsible radio list).

   Reported (feedback item 6): the same six finishing options appear twice -
   the left rail's Finishing panel and a tall card on the right. Confusing, and
   the card eats space. The store chose ruth's version from the Tuesday
   meeting: one dropdown, under the "Design" card in the right panel.

   MEASURED (live, custom-vinyl-banners): the right card is #sbdc-finrail,
   carrying six <button data-fin="..."> entries (hem-grommets, hem-only,
   grommets-only, none, pockets-both, pockets-top). The left rail has a
   Finishing button.

   HOW IT WORKS: the dropdown does not own the choice. It reads its options
   from the existing card and, when the customer picks one, CLICKS that card's
   own button. Every rule about which finishings a product allows, what they
   cost and how the board redraws stays where it was.

   ⚠ v3 - FINDING THE "Design" CARD. v2 matched the card by its whole
   textContent being "Design". That works on an empty board and fails the
   moment the design has text in it: the card holds a live thumbnail, so its
   textContent comes back as "VOT202LOGHERVOT202..." - every word on the
   customer's banner. The dropdown then fell back to the canvas column, which
   is what the store saw. v3 looks for a DESCENDANT whose own text is exactly
   "Design" (it is an <em>), so the thumbnail's contents cannot interfere.

   Order of operations matters: the card and the left rail button are hidden
   only AFTER the dropdown has rendered. If anything here fails, both original
   controls are still on screen and the customer is no worse off than today.

   Products with no finishing (flags, yard signs) never render the card, so
   nothing is added for them.

   Diagnostics: window.__dcFinDropdown() */
(function () {
  'use strict';

  var ID = 'sbdc-findrop', TICK = 700;

  var info = { built: false, options: 0, current: '', anchor: '', hidRail: false,
               hidLeft: false, picks: 0, why: '' };
  window.__dcFinDropdown = function () { return info; };

  function rail() { return document.getElementById('sbdc-finrail'); }

  function readOptions(r) {
    var out = [];
    r.querySelectorAll('button[data-fin]').forEach(function (b) {
      var id = b.getAttribute('data-fin');
      var label = (b.querySelector('b') && b.querySelector('b').textContent) || id;
      var hint = (b.querySelector('small') && b.querySelector('small').textContent) || '';
      out.push({ id: id, label: label.replace(/\s+/g, ' ').trim(), hint: hint.replace(/\s+/g, ' ').trim(),
                 on: b.className.indexOf('is-on') > -1 });
    });
    return out;
  }

  /* The Design card, found by its own label rather than by the card's text -
     see the v3 note. Falls back to the canvas column so the control never
     simply vanishes. */
  function anchor() {
    var cards = document.querySelectorAll('aside.sides-panel .side-card, .sides-panel .side-card');
    for (var i = 0; i < cards.length; i++) {
      var kids = cards[i].querySelectorAll('em, span, b, small, div');
      for (var j = 0; j < kids.length; j++) {
        if (kids[j].children.length) continue;
        if (/^design$/i.test((kids[j].textContent || '').replace(/\s+/g, ' ').trim())) {
          info.anchor = 'design-card';
          return cards[i];
        }
      }
    }
    var v = document.querySelector('.canvas-viewport');
    if (v) { info.anchor = 'canvas'; return v; }
    return null;
  }

  var el = null, nameEl = null, list = null, sig = '', idsSig = '';

  /* v4 (2026-09-15): a <select> cannot wrap, so "Pole pockets, top and bottom"
     was cut off. Now a <details>: closed shows Finishing, Free and the chosen
     name (wrapping); + opens a radio list with the hints. */
  function css() {
    if (document.getElementById(ID + '-css')) return;
    var st = document.createElement('style');
    st.id = ID + '-css';
    st.textContent =
      '#' + ID + '{margin:8px 0 0;border:1px solid #d8e0e8;border-radius:10px;background:#fff;box-sizing:border-box;' +
      'font-family:Arial,Helvetica,sans-serif;font-size:12.5px;color:#2c3a47}' +
      '#' + ID + '>summary{list-style:none;cursor:pointer;padding:10px;display:grid;grid-template-columns:1fr auto;gap:4px 6px;align-items:center}' +
      '#' + ID + '>summary::-webkit-details-marker{display:none}' +
      '#' + ID + ' .fd-head{display:flex;align-items:center;gap:6px}' +
      '#' + ID + ' .fd-head b{font-weight:700;color:#072747;font-size:13px}' +
      '#' + ID + ' .fd-free{background:#e7f4ea;color:#1c7a3a;border-radius:999px;padding:2px 7px;font-size:10.5px;font-weight:700}' +
      '#' + ID + ' .fd-pm{font-size:17px;line-height:1;color:#072747;font-weight:700}' +
      '#' + ID + ' .fd-pm::before{content:"+"}' +
      '#' + ID + '[open] .fd-pm::before{content:"\\2212"}' +
      '#' + ID + ' .fd-name{grid-column:1/-1;color:#072747;line-height:1.35;overflow-wrap:anywhere}' +
      '#' + ID + ' .fd-list{padding:0 10px 10px;display:flex;flex-direction:column;gap:6px}' +
      '#' + ID + ' label{display:flex;gap:7px;align-items:flex-start;cursor:pointer;line-height:1.35;color:#072747}' +
      '#' + ID + ' label input{margin:2px 0 0;flex:none}' +
      '#' + ID + ' label small{display:block;color:#6b7885;font-size:11.5px;line-height:1.4}';
    document.head.appendChild(st);
  }

  function build(opts) {
    var a = anchor();
    if (!a || !a.parentElement) return false;

    if (!el) {
      css();
      el = document.createElement('details');
      el.id = ID;
      el.open = true;   // 2026-09-29: starts open so the choices show on arrival; a pick still folds it
      el.innerHTML = '<summary><span class="fd-head"><b>Finishing</b><span class="fd-free">Free</span></span>' +
        '<span class="fd-pm" aria-hidden="true"></span><span class="fd-name"></span></summary>' +
        '<div class="fd-list" role="radiogroup" aria-label="Finishing"></div>';
      nameEl = el.querySelector('.fd-name');
      list = el.querySelector('.fd-list');
      list.addEventListener('change', function (e) {
        var r = rail();
        if (!r || !e.target.value) return;
        var btn = r.querySelector('button[data-fin="' + e.target.value + '"]');
        info.picks++;
        if (btn) btn.click();      // the card's own handler does the real work
        paintName();
      });
      /* a pick made with the mouse or a finger closes the list; arrow keys
         change the pick too, so the keyboard keeps it open */
      var byPointer = false;
      list.addEventListener('pointerdown', function () { byPointer = true; });
      list.addEventListener('keydown', function () { byPointer = false; });
      list.addEventListener('click', function (e) {
        if (e.target.tagName !== 'INPUT') return;   // a label click comes back as an input click
        if (byPointer) el.open = false;
        byPointer = false;
      });
    }

    if (el.previousElementSibling !== a || el.parentElement !== a.parentElement) {
      a.parentElement.insertBefore(el, a.nextSibling);
    }

    /* rebuild the radios only when the option set changes, so a keyboard
       user's focus survives the tick that follows their own pick */
    var ids = opts.map(function (o) { return o.id; }).join(',');
    if (ids !== idsSig) {
      idsSig = ids;
      list.innerHTML = '';
      opts.forEach(function (o) {
        var lab = document.createElement('label');
        lab.innerHTML = '<input type="radio" name="' + ID + '-r"><span><span class="fd-l"></span><small></small></span>';
        lab.querySelector('input').value = o.id;
        lab.querySelector('.fd-l').textContent = o.label;
        lab.querySelector('small').textContent = o.hint;
        list.appendChild(lab);
      });
    }
    var on = opts.filter(function (o) { return o.on; })[0] || opts[0];
    list.querySelectorAll('input').forEach(function (i) { i.checked = i.value === on.id; });
    info.built = true;
    info.options = opts.length;
    paintName();
    return true;
  }

  function paintName() {
    var c = list && list.querySelector('input:checked');
    info.current = c ? c.value : '';
    nameEl.textContent = c ? c.parentElement.querySelector('.fd-l').textContent : '';
  }

  function leftButton() {
    var all = document.querySelectorAll('.rail-btn');
    for (var i = 0; i < all.length; i++) {
      if (/^finishing$/i.test((all[i].textContent || '').replace(/\s+/g, ' ').trim())) return all[i];
    }
    return null;
  }

  var t = setInterval(function () {
    /* no 15-minute cut-off any more: after it, switching to a sticker left the
       box on screen. Each tick is a DOM read; building only runs on change. */
    var r = rail();
    /* no card = this product has no finishing: take our box away too, or the
       one built for the default product lingers (stickers showed Hem + Grommets) */
    if (!r) { info.why = 'no finishing card on this product'; if (el) { el.remove(); el.open = false; } return; }

    var opts = readOptions(r);
    if (!opts.length) return;

    var s = opts.map(function (o) { return o.id + (o.on ? '*' : ''); }).join(',') + '|' + info.anchor;
    if (s !== sig || !el || !el.parentElement) { sig = s; if (!build(opts)) return; }

    /* the Design card can appear after the first pass - move there when it does */
    if (info.anchor === 'canvas') {
      var a2 = anchor();
      if (a2 && info.anchor === 'design-card' && el) {
        a2.parentElement.insertBefore(el, a2.nextSibling);
      }
    }

    if (!info.built) return;
    if (r.style.display !== 'none') { r.style.display = 'none'; info.hidRail = true; }
    var lb = leftButton();
    if (lb) {
      var li = lb.closest('li') || lb;
      if (li.style.display !== 'none') { li.style.display = 'none'; info.hidLeft = true; }
    }
  }, TICK);

  addEventListener('pagehide', function () { clearInterval(t); });
})();
